<template>
    <b-tabs pills active-nav-item-class="nav-pill-warning" nav-class="bg-light p-25 mx-1 mt-1 custom-nav">
        <b-tab title="Sicil">
            <employee-registry-file-documents :id="id" :code="code"></employee-registry-file-documents>
        </b-tab>
        <b-tab title="SRC" lazy>
            <src-files :id="id" />
        </b-tab>
        <b-tab title="Sağlık Raporu" lazy>
            <health-report :id="id" />
        </b-tab>
        <b-tab title="Psikoteknik" lazy>
            <psychotechnic-files :id="id" />
        </b-tab>
        <b-tab title="ISG Eğitimleri" lazy>
            <ohs-education :id="id" />
        </b-tab>
        <b-tab title="Diğer Belgeler" lazy>
            <employee-documents :id="id" />
        </b-tab>
        <b-tab title="Sicil Belgeleri" lazy>
            <employee-sicil-file-documents :id="id" :code="code" />
        </b-tab>
    </b-tabs>
</template>

<script>
import { BTab, BTabs } from "bootstrap-vue";
import EmployeeRegistryFileDocuments from "../step-5-d/files/EmployeeRegistryFileDocuments.vue";
import EmployeeDocuments from "../step-4-d/EmployeeDocuments.vue";
import EmployeeSicilFileDocuments from "./sicil-files/EmployeeSicilFileDocuments.vue";
import SRCFiles from "./src-files/SRCFiles.vue";
import HealthReport from "./health-report/HealthReport.vue";
import PsychotechnicFiles from "./psychotechnic-files/PsychotechnicFiles.vue";
import OHSEducation from "./ohs-education/OHSEducation.vue";

export default {
    components: {
        BTab,
        BTabs,
        EmployeeRegistryFileDocuments,
        EmployeeDocuments,
        EmployeeSicilFileDocuments,
        "src-files": SRCFiles,
        HealthReport,
        PsychotechnicFiles,
        "ohs-education": OHSEducation,
    },
    props: {
        id: [String, Number],
        code: [String, null],
        collarStatus: {
            type: String,
            default: null,
        },
    },
};
</script>
